import _                                   from 'underscore';
import React, { FC }                       from 'react';
import { useQuery }                        from '@apollo/react-hooks';
import { formatOption }                    from '../../../../util';
import { SystemAccountingQueries }         from '../../../../queries';
import { SelectField }                     from '../../../components/forms';
import { Uuid }                            from '../../../../types';
import { SelectFieldProps }                from '../formik';
import { queriesHaveData, queriesLoading } from '../../../../store/_apolloUtil';

interface Props extends Omit<SelectFieldProps, 'options'> {
	organizationIds?: null | Uuid[],
	isActive?: null | boolean
}

const defaultProps: Props = {
	organizationIds: null,
	isActive:        null,
}

const Dropdown: FC<Props> = ( _props ) => {

	let { organizationIds, isActive, ...props } = _props,
	    queryWhere                              = null;

	if( !_.isNull( organizationIds ) || !_.isNull( isActive ) ){
		queryWhere = { where: { and: [] } }
	}

	if( isActive === true ){
		queryWhere?.where.and.push( { isActive: { eq: true } } )
	}

	if( isActive === false ){
		queryWhere?.where.and.push( { isActive: { eq: false } } )
	}

	if( !_.isNull( organizationIds ) && _.isArray( organizationIds ) ){
		queryWhere?.where.and.push( {
			id: { in: organizationIds }
		} )
	}

	let getCollectionReq = useQuery( SystemAccountingQueries.queries.GET_ORGANIZATIONS(), {
		fetchPolicy: 'cache-and-network',
		variables:   {
			...queryWhere,
			order: [ { name: "ASC" } ]
		}
	} );

	let isLoading = ( props.loading || queriesLoading( getCollectionReq ) );

	let options = queriesHaveData( getCollectionReq )
	              ? _.chain( getCollectionReq.data.organizations )
	                 .sortBy( 'name' )
	                 .map( o => formatOption( o.id, o.name ) )
	                 .value()
	              : [];

	return (
		<SelectField
			{ ...props }
			loading={ isLoading }
			options={ options }>
		</SelectField>
	);
};

Dropdown.defaultProps = defaultProps;

export { Dropdown as OrganizationsDropdown }
